// 3rd-party
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Config
import { appConfig } from "../../config/appConfig";

// Services
import { setStorageItemLocal } from "../../services/storageServices";

// Components
import Spinner from "../../components/spinner/Spinner";

// Asset components
import logo from "../../assets/ITC-Logo-1.svg";

// Styles
import "./LoginPage.scss";

const LoginPage = () => {
  const [email, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await fetch(appConfig.serviceUrls.getValidateUser, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json(); // Parse JSON
        navigate("/master/India", { replace: true });

        setStorageItemLocal("username", data.user.username);
        setStorageItemLocal("role", data.user.role);
        setStorageItemLocal("email", data.user.email);
        setStorageItemLocal("phonenumber", data.user.phonenumber);
        setStorageItemLocal("token", data.token);
        localStorage.setItem("isAuthenticated", "true");
        navigate("/master/India", { replace: true });
      } else {
        const message = await response.text();
        alert(message ?? "Invalide Credecial");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Network error");
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const handleResetPasswordClick = (): void => {
    if (!email.trim()) {
      alert("Please enter your username first.");
      return;
    }
    alert(`Username entered:${email}`);
    navigate("/reset-password", { state: { username: email } });
  };
  return (
    <div className="body-wrapper">
      <Container className="login-container" maxWidth="md">
        <Box className="login-wrapper">
          {loading ? (
            <>
              {" "}
              <Spinner></Spinner>
            </>
          ) : (
            <Box className="img-title">
              <img src={logo} alt="ITCMAP_Logo" className="app-logo" />
              <Box className="titles">
                <Typography className="login-heading">World of ITC</Typography>
              </Box>
            </Box>
          )}

          <TextField
            label="email ID"
            variant="outlined"
            value={email}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            autoComplete="off"
            className="margin-top-25"
            style={{ backgroundColor: "#fff" }}
          />
          <TextField
            label="Password"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            className="margin-top-25"
            style={{ backgroundColor: "#fff" }}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={togglePasswordVisibility}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            sx={{ backgroundColor: "#007bff" }}
            onClick={handleLogin}
            fullWidth
            className="margin-top-25 signin-btn"
          >
            Sign In
          </Button>
          <Typography
            onClick={() => {
              alert("Connect Admin for change Password");
            }}
            className="margin-top-25 forgot-password"
          >
            Forgot Password
          </Typography>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ display: 'block', textAlign: 'center', mt: 2 }}
          >
            Version 1.2.19
          </Typography>
        </Box>
      </Container>
    </div>
  );
};
export default LoginPage;
